module.exports = __webpack_public_path__ + "static/apparel-a08ec1f17effeb697bbdc101e91ea57d.png";